module.exports = __webpack_public_path__ + "static/media/liveizy-logo-inverse (1).446fbd2c.png";